import React, { useState, useEffect } from "react";
import { Modal, ModalBody, Row, Col } from "reactstrap";
import { SET_USER_AND_PLAN_DETAILS } from "../../../actions/types";
import { useDispatch } from "react-redux";
import axiosInstance from "../../../axios-instance";
import UpdateCardModal from "./update-card-modal";

const ConfirmPaymentModal = (props) => {
  const dispatch = useDispatch();
  const [data,                setData]                = useState(null);
  const [prorateLoading,      setProrateLoading]      = useState(false);
  const [prorateError,        setProrateError]        = useState("");
  const [isOpen,              setIsOpen]              = useState(false);
  const [showChangeCardModal, setShowChangeCardModal] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    setProrateLoading(true);
    setProrateError("");
    setData(null);

    axiosInstance
      .get(`/admin/get-prorated-charges/${props.plan_id}/${props.planPeriodType}`)
      .then((res) => {
        if (res.data.success) {
          setData(res.data);
        } else {
          setProrateError("Could not load billing preview. You can still proceed.");
        }
      })
      .catch(() => {
        setProrateError("Could not load billing preview. You can still proceed.");
      })
      .finally(() => {
        setProrateLoading(false);
      });
  }, [isOpen]);

  /**
   * on toggle modal
   */
  const toggle = () => {
    setIsOpen((prevState) => !prevState);
  };

  const { plan, userCurrentPlan, planPeriodType } = props;
  const currentPeriod =
    userCurrentPlan?.plan_period_type === "annual" ||
    userCurrentPlan?.plan_type === "annual"
      ? "annual"
      : "monthly";
  const viewingPeriod = planPeriodType === "annual" ? "annual" : "monthly";
  const isPeriodSwitch =
    String(plan.id) === String(userCurrentPlan?.plan_id) &&
    currentPeriod !== viewingPeriod;
  const isDowngrade =
    !isPeriodSwitch &&
    Number(userCurrentPlan?.monthly_price) > Number(plan.monthly_price);
  const actionLabel = isPeriodSwitch
    ? viewingPeriod === "annual"
      ? "Switch to Annually"
      : "Switch to Monthly"
    : isDowngrade
    ? "Downgrade Plan"
    : "Upgrade Plan";

  return (
    <>
      <button
        button
        className="btn btn-outline brand"
        onClick={(event) => {
          event.preventDefault();
          dispatch({
            type: SET_USER_AND_PLAN_DETAILS,
            payload: {
              selectedPlan: plan,
            },
          });
          toggle();
        }}
      >
        {actionLabel}
      </button>

      {showChangeCardModal && <UpdateCardModal toggle={setShowChangeCardModal}/>}
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalBody>
          <div className="">
            <div className="eventdetailsaddbox rd_modalvieew">
              <div className="box_content rd_modalboxcontent">
                <div className="rd_inputselectheadermodalsetting">
                  <button className="rd_colsebtn" onClick={toggle}></button>
                </div>

                <p className="rd_modalheadertextparath mt-5 mb-5">
                  {isPeriodSwitch
                    ? `Are you sure you want to switch this plan to ${
                        viewingPeriod === "annual" ? "annual" : "monthly"
                      } billing?`
                    : `Are you sure you want to ${
                        isDowngrade ? "downgrade" : "upgrade"
                      } your subscription plan?`}
                </p>

                {/* ── Billing preview ── */}
                {prorateLoading ? (
                  <p className="rd_modalheadertextparath mt-3 mb-3" style={{ color: "#9CA3AF" }}>
                    Loading billing preview…
                  </p>
                ) : prorateError ? (
                  <p className="rd_modalheadertextparath mt-3 mb-3" style={{ color: "#EF4444", fontSize: "13px" }}>
                    {prorateError}
                  </p>
                ) : data ? (
                  data.is_downgrade || isDowngrade ? (
                  <>
                    <p className="rd_modalheadertextparath mt-3 mb-3">
                      You’ll keep your current plan until{" "}
                      <span style={{ color: "#FE9920", fontWeight: "700" }}>
                        {data.effective_date || data.next_billing_date}
                      </span>
                      . You’ll move to {plan.plan_name} then.
                    </p>
                    <p className="rd_modalheadertextparath mt-3 mb-3">
                      Starting that date your{" "}
                      {props.planPeriodType === "monthly" ? "monthly" : "annual"} bill
                      will be{" "}
                      <span style={{ color: "#FE9920", fontWeight: "700" }}>
                        ${data.new_monthly_amount}
                      </span>
                      . You won’t be charged extra today.
                    </p>
                  </>
                  ) : (
                  <>
                    <p className="rd_modalheadertextparath mt-3 mb-3">
                      This upgrade takes effect immediately. Starting{" "}
                      <span style={{ color: "#FE9920", fontWeight: "700" }}>
                        {data.next_billing_date}
                      </span>
                      {" "}your {props.planPeriodType === "monthly" ? "monthly" : "annual"} bill
                      will be{" "}
                      <span style={{ color: "#FE9920", fontWeight: "700" }}>
                        ${data.new_monthly_amount}
                      </span>
                    </p>

                    <p className="rd_modalheadertextparath mt-3 mb-3">
                      An estimated prorated charge of{" "}
                      <span style={{ color: "#FE9920", fontWeight: "700" }}>${data.prorated_amount}</span>{" "}
                      {data.is_trialing
                        ? "will be $0 today during your trial. Your first invoice after the trial uses the new plan price."
                        : (
                          <>
                            will be applied on your{" "}
                            <span style={{ color: "#FE9920", fontWeight: "700", textTransform: "capitalize" }}>{data.card_brand}</span>{" "}
                            ending with{" "}
                            <span style={{ color: "#FE9920", fontWeight: "700" }}>{data.card_last_four}</span>.
                          </>
                        )}
                    </p>
                  </>
                  )
                ) : null}

                <Row className="mb-3">
                  <Col className="text-center">
                    <button className="btn btn_success btn-sm" onClick={() => setShowChangeCardModal(true)}>Change Card</button>
                  </Col>
                </Row>
                

                <div className="rd_cancelappbtnmodal">
                  <button className="btn btn-danger" onClick={toggle}>
                    Cancel
                  </button>
                  <button
                    className="btn btn-app"
                    onClick={() => {
                      props.upgradePlan({});
                      toggle();
                    }}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ConfirmPaymentModal;
